import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./PopUpStyle.css";
import { postDataFetcher } from "../../../dataFetcher";
import CONFIG_OBJECT from "../../../config/config";
import App_Constants from "../../../app-constants/App_Constants";
import configData from "../../../temp/config";
import { isMobile } from "react-device-detect";
import OutsideAlerter from "../outside-alerter/outsideAlerter";
import { registerLocale } from "react-datepicker";
import enIN from "date-fns/locale/en-IN";
registerLocale("enIN", enIN);

const PredictPhase = (props) => {
  let maxDate =
    props.periodDaysResponse != null
      ? props.periodDaysResponse[props.periodDaysResponse.length - 1].dates
          .length === 0
        ? new Date(
            props.periodDaysResponse[props.periodDaysResponse.length - 2].year,
            props.periodDaysResponse[props.periodDaysResponse.length - 2]
              .monthIndex - 1,
            props.periodDaysResponse[props.periodDaysResponse.length - 2].dates[
              props.periodDaysResponse[props.periodDaysResponse.length - 2]
                .dates.length - 1
            ].day
          )
        : new Date(
            props.periodDaysResponse[props.periodDaysResponse.length - 1].year,
            props.periodDaysResponse[props.periodDaysResponse.length - 1]
              .monthIndex - 1,
            props.periodDaysResponse[props.periodDaysResponse.length - 1].dates[
              props.periodDaysResponse[props.periodDaysResponse.length - 1]
                .dates.length - 1
            ].day
          )
      : new Date(new Date().getFullYear(), new Date().getMonth() + 11, 1);

  const [multidate, setmultidate] = useState(false);
  const [singledate, setsingledate] = useState(true);
  const [resultData, setresponseData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [futuredate, setlastPeriodFirstday] = useState(
    new Date().setDate(new Date().getDate() + 1)
  );
  const [todate, setToDate] = useState(
    new Date().setDate(new Date().getDate() + 2)
  );

  const togglePopup = () => {
    setIsOpen((prev) => !prev);
    if (isMobile) {
      props.setShowFilterPopup(false);
    }
  };

  const [fromDateOpen, setFromDateOpen] = useState(false);
  const [toDateOpen, setToDateOpen] = useState(false);

  const FromDateChange = (date) => {
    setlastPeriodFirstday(date);
    setFromDateOpen(false);
    let inputDate = new Date(date);
    let toDateSelected = new Date(todate);
    if (
      toDateSelected < inputDate ||
      (toDateSelected.getDate() === inputDate.getDate() &&
        toDateSelected.getMonth() === inputDate.getMonth() &&
        toDateSelected.getFullYear() === inputDate.getFullYear())
    ) {
      let toDate = new Date(date);
      if (toDate < maxDate) {
        setToDate(toDate.setDate(toDate.getDate() + 1));
      } else {
        setToDate(maxDate);
      }
    }
    if (toDateSelected > inputDate) {
      var Difference_In_Time = toDateSelected.getTime() - inputDate.getTime();
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      if (Difference_In_Days > 60) {
        let toDate = new Date(date);
        setToDate(toDate.setDate(toDate.getDate() + 1));
      }
    }
  };

  const ToDateChange = (date) => {
    setToDate(date);
    setToDateOpen(false);
  };

  const [validResponse, setValidResponse] = useState(false);
  const [disableCheckNow, setDisableCheckNow] = useState(false);

  useEffect(() => {
    if (disableCheckNow) {
      setDisableCheckNow(false);
    }
  }, [futuredate, todate]);

  const PredictPhase = () => {
    let restURL = `${configData.sitecoreApiHost}/${CONFIG_OBJECT.FUTURE_DATES_REST_URL}`;
    let periodDateComp = new Date(props.lastPeriodFirstday);
    periodDateComp.setHours(12, 0, 0, 0);
    let data = {
      lastPeriodDate: `${
        periodDateComp.getMonth() + 1
      }-${periodDateComp.getDate()}-${periodDateComp.getFullYear()}`,
      periodDuration: props.periodDuration,
      cycleLength: props.daysBetweenPeriod,
      StartDate: `${new Date(futuredate).getMonth() + 1}-${new Date(
        futuredate
      ).getDate()}-${new Date(futuredate).getFullYear()}`,
      EndDate: multidate
        ? `${new Date(todate).getMonth() + 1}-${new Date(
            todate
          ).getDate()}-${new Date(todate).getFullYear()}`
        : `${new Date(futuredate).getMonth() + 1}-${new Date(
            futuredate
          ).getDate()}-${new Date(futuredate).getFullYear()}`,
      resultData: resultData,
    };
    postDataFetcher(
      `${restURL}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem(
        "language"
      )}`,
      data
    ).then(
      (res) => {
        if (res.data.HasError) {
          console.log(res);
        } else {
          // debugger
          if (!disableCheckNow) {
            props.setPredictPhaseResponse(null);
            props.setPredictPhaseResponse(res.data.Data);
            console.log("res.data.Data", res.data.Data);
            if (res.data.Data != null) {
              setValidResponse(true);
            }
            props.setPredictPhaseFromDate(futuredate);
            props.setPredictPhaseToDate(multidate ? todate : null);
            if (!multidate) {
              props.setPredictPhaseToDate(null);
            }
            setDisableCheckNow(true);
            setIsOpen((prev) => !prev);
            if (document.getElementById("future-dates-response") != null) {
              document.getElementById("future-dates-response").scrollIntoView();
            }
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const setSingleDayEvent = () => {
    setmultidate(false);
  };

  const setMultiDayEvent = () => {
    setmultidate(true);
  };

  const onToggle = () => {
    setmultidate((prev) => !prev);
    setDisableCheckNow(false);
  };

  const ClosePopup = () => {
    if (isOpen && validResponse) {
      setmultidate(false);
      setsingledate(true);
      setresponseData([]);
      setValidResponse(false);
      props.setPredictPhaseResponse(null);
      ToDateChange(new Date().setDate(new Date().getDate() + 2));
      FromDateChange(new Date().setDate(new Date().getDate() + 1));
    }
  };

  const [outsideAlerter, setOutSideAlerter] = useState(false);
  const [buttonOutsideClick, setButtonOutsideClick] = useState(false);
  useEffect(() => {
    if (outsideAlerter && buttonOutsideClick) {
      setIsOpen(false);
      setButtonOutsideClick(false);
      setOutSideAlerter(false);
    }
  });
  const [fromDateOutsideClick, setFromDateOutsideClick] = useState(false);
  const [toDateOutsideClick, setToDateOutsideClick] = useState(false);
  useEffect(() => {
    if (!props.showPredictPhase) {
      setDisableCheckNow(false);
    }
  }, [props.showPredictPhase]);

  return (
    <>
      {!isMobile && (
        <OutsideAlerter
          className="col-sm-2"
          setIsClickedOutSide={setButtonOutsideClick}
        >
          <button
            className={
              props.showPredictPhase || isOpen
                ? "predict-view-options predict-view-options-selected"
                : "predict-view-options"
            }
            onClick={togglePopup}
          >
            {props.dictionary("PeriodCalculator_SelectFutureDate")}
          </button>
        </OutsideAlerter>
      )}
      {isMobile && (
        <OutsideAlerter
          className="predict-phase-button"
          setIsClickedOutSide={setButtonOutsideClick}
        >
          <button
            className={
              props.showPredictPhase || isOpen
                ? "view-options view-options-clicked"
                : "view-options"
            }
            onClick={togglePopup}
          >
            {props.dictionary("PeriodCalculator_SelectFutureDate")}
          </button>
        </OutsideAlerter>
      )}

      {isOpen && (
        <>
          {!isMobile && <div className="exit-predict-phase"></div>}
          <OutsideAlerter
            className="popup-box"
            setIsClickedOutSide={setOutSideAlerter}
          >
            <div
              className={
                isMobile ? "submitBtnWrapper d-flex" : "submitBtnWrapper"
              }
            >
              {singledate && (
                <div className={isMobile ? "col-4" : "col-sm-3"}>
                  {
                    <>
                      {singledate && !multidate && (
                        <p className="predict-phase-label">
                          {props.dictionary("PeriodCalculator_SingleDayDate")}
                        </p>
                      )}
                      {multidate && (
                        <p className="predict-phase-label">
                          {props.dictionary(
                            "PeriodCalculator_MultiDayStartDate"
                          )}
                        </p>
                      )}
                      <a
                        className={
                          isMobile
                            ? "track-my-period-anchor right predict-phase-from-date"
                            : "track-my-period-anchor predict-phase-from-date"
                        }
                      >
                        <span>
                          <img
                            src={`${configData.sitecoreApiHost}/${props.calenderIcon}`}
                            className="input-images"
                            alt="cal_alt"
                            width=""
                            onClick={() => {
                              if (!fromDateOutsideClick) {
                                setFromDateOpen((prev) => !prev);
                              } else {
                                setFromDateOutsideClick(false);
                              }
                            }}
                          />
                          <DatePicker
                            dateFormat="dd MMM, yyy"
                            monthsShown={1}
                            locale="enIN"
                            endDate={Date.now}
                            showPopperArrow={false}
                            minDate={
                              new Date(
                                new Date().getFullYear(),
                                new Date().getMonth(),
                                new Date().getDate() + 1
                              )
                            }
                            maxDate={maxDate}
                            placeholderText={props.dictionary(
                              "PeriodCalculator_MultiDayStartDatePH"
                            )}
                            onChange={FromDateChange}
                            selected={futuredate}
                            open={fromDateOpen}
                            onInputClick={() => {
                              setFromDateOpen((prev) => !prev);
                            }}
                            onClickOutside={() => {
                              setFromDateOpen(false);
                              setFromDateOutsideClick(true);
                            }}
                          />
                        </span>
                      </a>
                    </>
                  }
                </div>
              )}
              <div className={isMobile ? "col-4" : "col-sm-3"}>
                <div className="toggle-switch-value">
                  <div className="switch-box-wrapper">
                    <p
                      className={
                        multidate
                          ? isMobile
                            ? "unit-text disabled-unit-text mr-2"
                            : "unit-text disabled-unit-text"
                          : isMobile
                          ? "unit-text mr-2"
                          : "unit-text"
                      }
                      onClick={setSingleDayEvent}
                    >
                      {isMobile
                        ? props.dictionary(
                            "PeriodCalculator_SingleDayMobileToggle"
                          )
                        : props.dictionary("PeriodCalculator_SingleDayToggle")}
                    </p>
                    <label className="toggle-unit-switch">
                      <input
                        type="checkbox"
                        checked={multidate}
                        onChange={onToggle}
                      />
                      <span className="switch" />
                    </label>
                    <p
                      className={
                        !multidate
                          ? "unit-text disabled-unit-text ml-2"
                          : "unit-text ml-2"
                      }
                      onClick={setMultiDayEvent}
                    >
                      {isMobile
                        ? props.dictionary(
                            "PeriodCalculator_MultiDayMobileToggle"
                          )
                        : props.dictionary("PeriodCalculator_MultiDayToggle")}
                    </p>
                  </div>
                </div>
              </div>
              <div className={isMobile ? "col-4" : "col-sm-3"}>
                {multidate && (
                  <>
                    <p className="predict-phase-label">
                      {props.dictionary("PeriodCalculator_MultiDayEndDate")}
                    </p>
                    <a className="track-my-period-anchor predict-phase-from-date">
                      <span>
                        <img
                          src={`${configData.sitecoreApiHost}/${props.calenderIcon}`}
                          className="input-images"
                          alt="cal_alt"
                          width=""
                          onClick={() => {
                            if (!toDateOutsideClick) {
                              setToDateOpen((prev) => !prev);
                            } else {
                              setToDateOutsideClick(false);
                            }
                          }}
                        />
                        <DatePicker
                          dateFormat="dd MMM, yyy"
                          monthsShown={1}
                          endDate={Date.now}
                          locale="enIN"
                          showPopperArrow={false}
                          minDate={
                            new Date(
                              new Date(futuredate).getFullYear(),
                              new Date(futuredate).getMonth(),
                              new Date(futuredate).getDate() + 1
                            )
                          }
                          maxDate={
                            futuredate <
                            new Date(
                              maxDate.getFullYear(),
                              maxDate.getMonth(),
                              new Date(
                                maxDate.getFullYear(),
                                maxDate.getMonth() + 11,
                                1
                              ).getDate() - 61
                            )
                              ? new Date(futuredate).setDate(
                                  new Date(futuredate).getDate() + 60
                                )
                              : maxDate
                          }
                          placeholderText={props.dictionary(
                            "PeriodCalculator_MultiDayEndDatePH"
                          )}
                          onChange={ToDateChange}
                          selected={todate}
                          open={toDateOpen}
                          onInputClick={() => {
                            setToDateOpen((prev) => !prev);
                          }}
                          onClickOutside={() => {
                            setToDateOpen(false);
                            setToDateOutsideClick(true);
                          }}
                        />
                      </span>
                    </a>
                  </>
                )}
              </div>
              {(singledate || multidate) && !isMobile && (
                <div class={"col-sm-3"}>
                  <button
                    type="submit"
                    id="calculate-period-button-new-id"
                    onClick={PredictPhase}
                    className="predict-phase-submit"
                    disabled={disableCheckNow}
                  >
                    <span>{props.dictionary("PeriodCalculator_CheckNow")}</span>
                  </button>
                  {props.showPredictPhase && validResponse && isOpen && (
                    <button
                      type="submit"
                      id="calculate-period-button-new-id"
                      onClick={ClosePopup}
                      className="predict-phase-submit ml-5"
                    >
                      <span>
                        {props.dictionary("PeriodCalculator_PredictPhaseClear")}
                      </span>
                    </button>
                  )}
                </div>
              )}
            </div>
            {(singledate || multidate) && isMobile && (
              <>
                <div className="d-flex">
                  <div class={validResponse ? "col-6 left-button" : "col-12"}>
                    <button
                      type="submit"
                      id="calculate-period-button-new-id"
                      onClick={PredictPhase}
                      className="predict-phase-submit"
                      disabled={disableCheckNow}
                    >
                      <span>
                        {props.dictionary("PeriodCalculator_CheckNow")}
                      </span>
                    </button>
                  </div>
                  <div class={validResponse ? "col-6" : "d-none"}>
                    <button
                      type="submit"
                      id="calculate-period-button-new-id"
                      onClick={ClosePopup}
                      className="predict-phase-submit"
                    >
                      <span>
                        {props.dictionary("PeriodCalculator_PredictPhaseClear")}
                      </span>
                    </button>
                  </div>
                </div>
              </>
            )}
          </OutsideAlerter>
        </>
      )}
    </>
  );
};

export default PredictPhase;
